import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Users, Gift, Save } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AdminReferral() {
  const [data, setData] = useState(null);
  const [prize, setPrize] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const { data } = await api.get("/referral/leaderboard");
    setData(data);
    setPrize(data.prize || "");
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/referral/settings", { prize });
      toast.success("Premio 'Porta un amico' aggiornato");
      load();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  if (data === null) return <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;
  const rows = data.rows || [];

  return (
    <div className="space-y-6">
      <h2 className="font-display text-2xl font-extrabold uppercase text-zinc-950">Classifica "Porta un amico"</h2>

      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="mb-3 flex items-center gap-2">
          <Gift className="h-5 w-5 text-green-600" />
          <Label className="text-sm font-bold uppercase tracking-wide">Premio in palio (referral)</Label>
        </div>
        <div className="flex gap-2">
          <Input data-testid="referral-prize-input" value={prize} onChange={(e) => setPrize(e.target.value)} placeholder="Es. Maglia ufficiale autografata" className="rounded-xl" />
          <Button data-testid="referral-prize-save" onClick={save} disabled={saving} className="rounded-full bg-zinc-950 font-bold text-green-400 hover:bg-zinc-800">
            <Save className="mr-1 h-4 w-4" /> Salva
          </Button>
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="admin-referral-table">
        <div className="flex items-center gap-2 bg-slate-50 px-4 py-3 text-xs font-bold uppercase tracking-wide text-zinc-500">
          <Users className="h-4 w-4" /> Punti da inviti (5 pt per amico iscritto)
        </div>
        {rows.length === 0 ? (
          <p className="p-6 text-center text-sm text-zinc-400">Nessun invito registrato finora.</p>
        ) : rows.map((r) => (
          <div key={r.username} className="flex items-center gap-4 border-t border-slate-100 px-4 py-3">
            <span className="w-8 font-mono-t text-sm font-black text-zinc-400">{r.rank}</span>
            <span className="flex-1 truncate font-semibold text-zinc-900">{r.username}</span>
            <span className="text-xs font-semibold text-zinc-400">{r.invited_count} amici</span>
            <span className="w-16 text-right font-mono-t font-black text-green-600">{r.points} pt</span>
          </div>
        ))}
      </div>
    </div>
  );
}
